export default "__VITE_ASSET__B69NXH6S__"